import React from 'react'
import Navbar from './components/navbar';
import Hero from './components/hero';
import Highlights from './components/highlights';
import Model from './components/Model';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Footer from './components/Footer';

import * as Sentry from  '@Sentry/react';


const App = () => {

  return (
    <main>
      <Navbar/>
      <Hero />
      <Highlights />
      <Model/>
      <Features/>
      <HowItWorks/>
      <Footer/>
   </main>
   
   
  )
}

export default Sentry.withProfiler(App);
